import { defineComponent as _defineComponent } from 'vue'
import { ref, inject } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  ConclusionStep,
  ContentDisplay,
  HeadingDisplay,
  ListDisplay,
  ButtonPrimary
} from '@warrenbrasil/nebraska-web';


export default /*#__PURE__*/_defineComponent({
  __name: 'Conclusion',
  setup(__props) {

const router = useRouter();

const portfolioName = inject('portfolioName') as string;
const injectPortfolioId = inject('portfolioId') as string;

const portfolioId = ref(injectPortfolioId);

function invest() {
  router.push({
    name: 'investment-transaction',
    params: { portfolio: portfolioId.value }
  });
}

function goPortfolio() {
  router.push({
    name: 'wealthPortfolio',
    params: { id: portfolioId.value }
  });
}

return { __sfc: true,router, portfolioName, injectPortfolioId, portfolioId, invest, goPortfolio, ConclusionStep, ContentDisplay, HeadingDisplay, ListDisplay, ButtonPrimary }
}

})